import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {Form, Button, Row, Col, Card} from 'react-bootstrap';
import {Formik, ErrorMessage, Form as FormikForm} from 'formik';

import PasswordState from './PasswordState';
import useIsPasswordValid from '../util/isPasswordValid';

const ForgotPassword = props => {
	function validate(values) {
		const errors = {};
		const {isValid} = useIsPasswordValid(values.newPassword);
		if (!isValid) {
			errors.newPassword = 'New password is invalid.';
		}
		if (values.newPassword !== values.newPasswordConfirm) {
			errors.newPasswordConfirm = 'Your passwords do not match.';
		}

		return errors;
	}

	return (
		<Row>
			<Col sm={{span: 8, offset: 2}} md={{span: 6, offset: 3}} lg={{span: 4, offset: 4}}>
				<Card>
					<Card.Body>
						{props.data ? (
							<Fragment>
								<p className="text-success">Your password has been successfully changed!</p>
								<div>Redirecting to log in page...</div>
							</Fragment>
						) : (
							<Fragment>
								<p>Enter your new password.</p>
								<Formik
									initialValues={{newPassword: '', newPasswordConfirm: ''}}
									onSubmit={props.onSubmit}
									enableReinitialize={true}
									validate={validate}
								>
									{({handleChange, handleBlur, isSubmitting, values, errors, touched, isValid}) => (
										<FormikForm>
											<Form.Group className={touched.email && errors.email ? 'has-danger' : ''}>
												<Form.Control
													name="newPassword"
													type="password"
													value={values.newPassword}
													placeholder="New password"
													onChange={handleChange}
													onBlur={handleBlur}
													className={touched.newPassword && errors.newPassword ? 'is-invalid' : ''}
												/>
												<PasswordState password={values.newPassword} />
											</Form.Group>
											<Form.Group className={touched.email && errors.email ? 'has-danger' : ''}>
												<Form.Control
													name="newPasswordConfirm"
													type="password"
													value={values.newPasswordConfirm}
													placeholder="Confirm new password"
													onChange={handleChange}
													onBlur={handleBlur}
													className={touched.newPasswordConfirm && errors.newPasswordConfirm ? 'is-invalid' : ''}
												/>
												<ErrorMessage component="div" className="invalid-feedback" name="newPasswordConfirm" />
											</Form.Group>

											{props.error && <div className="text-danger">{props.error}</div>}
											{props.data && (
												<p className="text-success">A reset password link has been sent to your email adress.</p>
											)}
											<Button disabled={isSubmitting || props.data || !isValid} type="submit">
												{isSubmitting ? 'Changing...' : 'Change Password'}
											</Button>
										</FormikForm>
									)}
								</Formik>
							</Fragment>
						)}
					</Card.Body>
				</Card>
			</Col>
		</Row>
	);
};

ForgotPassword.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default ForgotPassword;
